export default {
  Checkout: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "checkout"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Checkout.js
// module id = A0qH
// module chunks = 32